<section class="edits">
  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading">
    <div class="spinner"></div>
    <p>Loading edits...</p>
  </div>

  <!-- No edits message -->
  <div *ngIf="!isLoading && edits.length === 0" class="no-edits">
    <p>No edits for this file.</p>
    
    <div>
      <button class="analyze-btn"
              [disabled]="analysisStarted || isSubmitting"
              [attr.title]="analysisStarted ? 'This contract has already been submitted for analysis.' : null"
              (click)="analyzeContract()">
        {{ isSubmitting ? 'Starting…' : analysisStarted ? 'Analysis Submitted' : 'Analyze Contract' }}
      </button>
    </div>

    <div *ngIf="analysisStarted" class="analysis-message">
      <p>This contract has already been submitted for analysis, so it can't be analyzed again. It may take several minutes before suggested edits show up here — reopen this file to check.</p>
    </div>

    <div *ngIf="analysisError" class="analysis-message analysis-message--error">
      <p>{{ analysisError }}</p>
    </div>
  </div>

  <!-- Edits list -->
  <div *ngIf="!isLoading && edits.length > 0">
    <header class="edits__header">
      <h2>Recommended Edits</h2>
    </header>

    <article class="edit" *ngFor="let e of edits; let i = index">
      <div class="edit__head" (click)="toggle(i)">
        <h3 class="edit__summary">{{ e.summary }}</h3>

        <div class="meta">
          <span class="pill">{{ e.editType }}</span>
        </div>

        <button class="chev"
                type="button"
                [attr.aria-expanded]="isOpen(i)"
                [attr.aria-controls]="'body-'+i">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path [attr.d]="isOpen(i) ? 'M7 14l5-5 5 5' : 'M7 10l5 5 5-5'"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="edit__body" [id]="'body-'+i" [hidden]="!isOpen(i)">
        <p class="edit__desc" *ngIf="e.detailedDescription">{{ e.detailedDescription }}</p>

        <div class="diff">
          <div class="diff__col">
            <h4>Original</h4>
            <pre>{{ e.originalText }}</pre>
          </div>
          <div class="diff__col">
            <h4>Suggested</h4>
            <div class="box rich" [innerHTML]="trustHtml(e.suggestedText)"></div>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>
